module.exports = __webpack_public_path__ + "media/images/iconCheck__inFrontOfAccent-2958c058b68b9cbdeda87ef38b150d51.png";